var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.97 10C5.17 10 2.43 8.47 0.24 5.69C-0.08 5.29 -0.08 4.72 0.24 4.32C2.43 1.53 5.17 0 7.97 0C10.77 0 13.51 1.53 15.7 4.31C16.02 4.71 16.02 5.28 15.7 5.68C13.52 8.47 10.77 10 7.97 10ZM2.27 5C3.43 6.31 5.42 8 7.97 8C10.52 8 12.51 6.31 13.67 5C12.51 3.69 10.52 2 7.97 2C5.42 2 3.43 3.69 2.27 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97022 5C8.42022 5 7.97021 4.55 7.97021 4C7.97021 3.6 8.21022 3.26 8.55022 3.1C8.37022 3.04 8.18021 3 7.97021 3C6.87021 3 5.97021 3.9 5.97021 5C5.97021 6.1 6.87021 7 7.97021 7C9.07021 7 9.97022 6.1 9.97022 5C9.97022 4.8 9.93021 4.6 9.87021 4.42C9.72021 4.76 9.37022 5 8.97022 5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.94904cc2.svg";
export { ForwardRef as ReactComponent };